import { __assign } from "tslib";
import React, { Suspense } from 'react';
import Skeletons from '../../infoui-components/components/Skeleton';
var loading = function (ioMode, ioTheme, styleName) {
    return React.createElement(Skeletons, { count: 1, ioMode: ioMode, ioTheme: ioTheme, styleName: styleName });
};
var BootstrapTableHeaderColumnComponent = React.lazy(function () {
    return import('../../bootstrap-components/components/BTTableHeaderColumnComponent');
});
var tableHeaderColumnComponent = function (props) {
    console.log('tableHeaderColumnComponent:::' + JSON.stringify(props));
    return (React.createElement(BootstrapTableHeaderColumnComponent, __assign({}, props)));
};
export var TableHeaderColumnComponent = function (props) {
    var componentToDisplay = tableHeaderColumnComponent(props);
    return (React.createElement(React.Fragment, null,
        React.createElement(Suspense, { fallback: loading(props.ioMode, props.ioTheme, props.styleName) }, componentToDisplay)));
};
export default TableHeaderColumnComponent;
//# sourceMappingURL=TableHeaderColumnComponent.js.map